import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useHomeStore from '../store/homeStore';
import useSearchStore from '../store/searchStore';
import { isEmpty } from 'underscore';

export const useHeaderPopup = () => {
  const navigate = useNavigate();

  const {
    setShowSearch,
    setShowPricingModal,
    setShowFeaturesModal,
    setShowContactModal,
    setShowNotifications,
    setShowDownloadApiModal,
    setShowGetStartedModal,
  } = useHomeStore();

  const { setSearchId } = useSearchStore();

  const closeAllModals = useCallback(() => {
    setShowPricingModal(false);
    setShowSearch(false);
    setShowContactModal(false);
    setShowFeaturesModal(false);
    setShowGetStartedModal(false);
    setShowDownloadApiModal(false);
    setShowNotifications(false);
  }, []);

  const openModalByRoute = useCallback(
    (pageId: string, splitPath: string[]) => {
      closeAllModals();
      switch (pageId) {
        case 'metadata':
          if (!isEmpty(splitPath[1])) {
            setSearchId(splitPath[1]);
          }
          setShowSearch(true);
          break;
        case 'pricing':
          setShowPricingModal(true);
          break;
        case 'features':
          setShowFeaturesModal(true);
          break;
        case 'contact':
          setShowContactModal(true);
          break;
        case 'notifications':
          setShowNotifications(true);
          break;
        case 'api':
          setShowDownloadApiModal(true);
          break;
        case 'getstarted':
          setShowGetStartedModal(true);
          break;
        default:
          break;
      }
    },
    []
  );

  const navigateToHome = useCallback(() => navigate('/'), [navigate]);

  return {
    closeAllModals,
    openModalByRoute,
    navigateToHome,
  };
};
